import * as React from 'react';
import { WarningIcon } from '../Icons';
import { EventHandler } from 'src/webportal/components/hocs/EventHandler';
import { Filespace } from 'fs-api-client';

interface FileSpaceCardButtonProperties {
    isFilespaceSuspended?: boolean;
    isUserSuspended?: boolean;
    credentialsAreAdded: boolean;
    filespaceName: string;
    domainName: string;
    isLegacySandboxStyle?: boolean;
    filespace?: Filespace | null;
    isErrored: boolean;
}

export function openFileSpace(fileSpaceName: string, domainName: string): void {
    let link = `lucid://lucidlink.com/fs/link?fileSystemName=${fileSpaceName}.${domainName}`;
    window.location.href = link;
}

function getSuspendedFooter() {
    return (
        <div className="warning-box">
        <div>
            <WarningIcon width="18px" height="17px" />
            <p>
                Restoring your Filespace…<br />
                (could take several minutes)
            </p>
        </div>
    </div>
    );
}

function getButtonOpen(props: any) {
    return (
        <React.Fragment>
            {props.isFilespaceSuspended && !props.isUserSuspended && getSuspendedFooter()}

            {!props.isFilespaceSuspended && !props.isUserSuspended && <a onClick={() => { openFileSpace(props.filespaceName, props.domainName); }} className="btn btn-outline-primary open-marker desktop">Open</a>}
            <div className="warning-box mobile">
                <div>
                    <WarningIcon width="18px" height="17px" />
                    <p>
                    Use desktop to access the filespace.
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
}

function getButtonInit(props: any) {
    return (
        <React.Fragment>
            {props.isFilespaceSuspended && !props.isUserSuspended && getSuspendedFooter()}
            {!props.isFilespaceSuspended && !props.isUserSuspended  && <a onClick={() => { EventHandler.onFsInitializationWindowOpen(props.filespace); }} href="#" data-toggle="modal" data-target="#initializeModal" className="btn initialize-marker desktop">Initialize</a>}
                <div className="warning-box mobile">
                    <div>
                        <WarningIcon width="18px" height="17px" />
                        <p>
                            Use desktop to initialize the filespace.
                        </p>
                    </div>
                </div>
        </React.Fragment>
    );
}

export default function FileSpaceCardButton(props: FileSpaceCardButtonProperties) {
    if (props.isErrored) {
        return null;
    }
    return props.credentialsAreAdded ? getButtonOpen(props) : getButtonInit(props);
}



// WEBPACK FOOTER //
// ./src/webportal/components/common/filespaceCardComponents/FilespaceCardButton.tsx